<div fxLayout="column" fxLayoutAlign="start start" class="w-100">
    <div class="container" fxLayout="row" fxLayoutAlign="space-between center"
         [class.unread]="inquiryInfo.isUnread">
        <div fxLayout="row"
             fxLayoutAlign="start center"
             [class.pl-32]="!isInquiry">
            @if (!isInquiry) {
                <ui-kit-svg
                    class="i-16"
                    name="ic_response"/>
            }
            <div class="t2 ml-8 max-w-56"
                 [innerHtml]="(isInquiry ? 'i18n_af_labelInquiryFromTo' : 'i18n_af_labelResponseFromTo') | translate : {
                    senderName: senderOrganizationInfo.name_ru,
                    senderEmail: inquiryInfo.sender.email,
                    receiverName: receiverOrganizationInfo.name_ru,
                    class: 't2-semi-bold'
                }">
            </div>
            <ui-kit-button type="text"
                           class="ml-16"
                           [label]="'i18n_af_buttonReadMore' | translate"
                           [isSmall]="true"
                           (clickListener)="sendRead()"/>
        </div>
        <div class="t5 c-primary-gray-400">{{ inquiryInfo.createdDate | date : 'HH:mm' }}</div>
    </div>
    @if (shouldShowDetails) {
        <div class="details-container" fxLayout="column" fxLayoutAlign="start start">
            <div class="t2 c-primary-gray-600">
                {{ (isInquiry ? 'i18n_af_labelInquiryDetails' : 'i18n_af_labelResponseDetails') | translate }}
            </div>
            <div class="t2 c-primary-gray-900 mt-8 pre-line">{{ inquiryInfo.additionalData.description }}</div>
            @if (attachments?.length) {
                <af-file-group-preview class="mt-24"
                                  [attachments]="attachments"
                                  [title]="'i18n_af_labelDocuments'"
                                  [showDownloadAll]="true"
                                  [spinnerId]="'documentsDownload' + inquiryInfo.id"/>
            }
        </div>
    }
    @if (shouldShowDetails && isInquiry && !hasResponse && !isDeleted && authHolderService.organizationBin === receiverOrganizationInfo.code) {
        <form
            [formGroup]="form"
            (submit)="sendResponse()"
            (keydown.control.enter)="form.valid && sendResponse()"
            class="details-container"
            fxLayout="column"
            fxLayoutAlign="start start">
            <div class="t2 c-primary-gray-600">{{ 'i18n_af_labelResponseDetails' | translate }}</div>
            <mat-form-field class="mt-4 w-100">
        <textarea matInput
                  #descriptionArea
                  maxlength="{{DESCRIPTION_MAX_LENGTH}}"
                  class="resize-none pt-12 pb-12"
                  formControlName="description"
                  [placeholder]="'i18n_af_placeholderIncidentDescription' | translate"></textarea>
                <mat-hint align="start" class="t5 c-primary-gray-600">{{ descriptionArea.value.length }}/ {{ DESCRIPTION_MAX_LENGTH }}
                </mat-hint>
            </mat-form-field>
            @if (form.controls.files) {
                <af-files
                    class="w-100 mt-40"
                    dropZoneStyle="dark"
                    [excludeItemsWithCode1]="true"
                    [form]="form.controls.files"
                    [bucket]="BucketName.INQUIRY_FILES"
                    [maxFileCount]="MAX_FILES_COUNT"/>
            }
            <ui-kit-button class="mt-16"
                           [spinnerId]="'sendResponse_' + inquiryInfo.id"
                           [label]="'i18n_af_buttonSend' | translate"
                           [disabled]="form.invalid"/>
        </form>
    }
</div>
